import { getDirectusToken } from '../../../utils/localStorage';
import { loginDirectus } from './login';

const DIRECTUS_URL = process.env.REACT_APP_DIRECTUS_URL;

async function fetchWithAuth(url, options = {}, { user, password } = {}) {
  let token = getDirectusToken();
  if (!token && user && password) {
    token = await loginDirectus(user, password);
  }
  let response = await fetch(url, {
    ...options,
    headers: options.headers,
    body: options.body
  });
  if (response.status === 401 && user && password) {
    token = await loginDirectus(user, password);
    response = await fetch(url, {
      ...options,
      headers: options.headers,
      body: options.body
    });
  }
  return response;
}

/**
 * Lädt eine Datei nach Directus hoch (directus_files).
 * @param {File} file
 * @param {{ user, password }} credentials
 * @returns {Promise<{ id: string }>} File-Objekt mit id
 */
export async function uploadFile(file, { user, password } = {}) {
  if (!DIRECTUS_URL) throw new Error('REACT_APP_DIRECTUS_URL fehlt.');
  const token = getDirectusToken() || (user && password ? await loginDirectus(user, password) : null);
  if (!token) throw new Error('Nicht authentifiziert (Directus).');

  const formData = new FormData();
  formData.append('file', file);

  const url = `${DIRECTUS_URL.replace(/\/$/, '')}/files`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData
  });

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(`Directus file upload: ${response.status} ${text}`);
  }
  const payload = await response.json();
  const data = payload?.data ?? payload;
  const id = data?.id ?? data?.key;
  if (id == null) throw new Error('Directus file upload: keine id in Antwort.');
  return { id, ...data };
}
